import {
	ChangeDetectorRef,
	Component,
	HostListener,
	OnInit,
	TemplateRef
} from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CookieService } from 'ngx-cookie-service';
import { OptimNotification } from 'src/app/shared/models/optim-notification';
import { FacadeService } from '../../services/facade.service';
import { Notification } from 'src/app/shared/models/notification';
import { MessageNotification } from 'src/app/shared/models/message-notification';
import { User } from 'src/app/shared/models/security/user';
import { Employee } from 'src/app/shared/models/employee/employee';

@Component({
	selector: 'app-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {
	modalRef?: BsModalRef;

	// Suffixe à ajouter au "Isy" en haut à gauche de l'écran
	appName = 'planning';

	// Titre de la page actuel, afficher dans la navbar à côter du bouton de menu
	currentPageTitle = 'Tableau de bord';

	optimNotifications: OptimNotification[];
	messagingNotifications: MessageNotification[];

	currentEmployee: Employee;

	isPrescriber: boolean = false;

	constructor(
		private modalService: BsModalService,
		private facade: FacadeService,
		private router: Router
	) {
		this.isPrescriber = this.facade.dataStorageService.isPrescriber();
		if (!this.isPrescriber) {
			if (this.facade.dataStorageService.isSSIAD()) {
				this.appName = 'health';
			}
		}

		this.router.events.subscribe((event: any) => {
			if (event instanceof NavigationEnd) {
				const url = event.url;
				if (url.includes('dashboard')) {
					this.currentPageTitle = 'Tableau de bord';
				} else if (url.includes('gestion')) {
					this.currentPageTitle = 'Gestion des données';
				} else if (url.includes('planning')) {
					this.currentPageTitle = 'Gestion des plannings';
				} else if (url.includes('route')) {
					this.currentPageTitle = 'Gestion des tournées';
				} else if (url.includes('messagerie')) {
					this.currentPageTitle = 'Messagerie';
				} else if (url.includes('reports')) {
					this.currentPageTitle = 'Rapports';
				} else {
					this.currentPageTitle = 'Espace personnel';
				}
			}
		});
	}

	ngOnInit(): void {
		this.currentEmployee = this.facade.dataStorageService.getUser().employee;

		this.facade.notificationService
			.getNotifications(this.facade.dataStorageService.getUser()?.id)
			.subscribe((notifications: Notification) => {
				this.optimNotifications = notifications.optimNotifications;
				this.messagingNotifications = notifications.messageNotifications;
			});

		const previousUrl = history.state.prevPage ?? null;
		if (!previousUrl) {
			this.updatePageTitleAfterRefresh();
		}
	}

	updatePageTitleAfterRefresh() {
		const location = window.location.pathname;

		if (location.includes('dashboard')) {
			this.currentPageTitle = 'Tableau de bord';
		} else if (location.includes('gestion')) {
			this.currentPageTitle = 'Gestion des données';
		} else if (location.includes('planning')) {
			this.currentPageTitle = 'Gestion des plannings';
		} else if (location.includes('route')) {
			this.currentPageTitle = 'Gestion des tournées';
		} else if (location.includes('messagerie')) {
			this.currentPageTitle = 'Messagerie';
		} else if (location.includes('reports')) {
			this.currentPageTitle = 'Rapports';
		} else {
			this.currentPageTitle = 'Espace personnel';
		}
	}

	openModal(template: TemplateRef<any>) {
		this.modalRef = this.modalService.show(template);
	}

	goToDashboard(): void {
		this.router.navigate(['dashboard']);
	}

	signOut() {
		this.modalRef?.hide();
		this.clearStorage();
	}

	/**
	 * Efface les éléments stockés en cache
	 */
	clearStorage() {
		this.facade.notificationService.ngOnDestroy();
		this.facade.messageService.ngOnDestroy();
		this.facade.dataStorageService.clearStorage();
		location.reload();
	}
}
